import { SmartBannerAnalytics } from "./smart-banner-analytics";

class Bakery {
    static getCookieExpiresString(hideTtl: number): string {
        const now = new Date();
        const expireTime = new Date(now.getTime() + hideTtl);
        return `expires=${expireTime.toUTCString()};`;
    }

    static bake(hideTtl: number | false, hidePath: string): void {
        document.cookie = `smartbanner_exited=1; ${
            hideTtl ? Bakery.getCookieExpiresString(hideTtl) : ""
        } path=${hidePath}`;
    }

    static unbake(): void {
        document.cookie = "smartbanner_exited=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
}

export default class SmartBanner {
    private options = {
        hideTtl: "2592000000",
        hidePath: "/",
    };
    private platform = "";
    private dataLayerAppCode = "";

    constructor() {
        const smartBannerDiv = document.querySelector<HTMLElement>(".js_smartbanner");
        this.platform = smartBannerDiv?.dataset.smartPlatform ?? "";
        this.dataLayerAppCode = smartBannerDiv?.dataset.aCodename ?? "";
        const event = new Event("smartbanner.init");
        document.dispatchEvent(event);
    }

    get height(): number {
        return document.querySelector<HTMLElement>(".js_smartbanner")?.offsetHeight ?? 0;
    }

    get positioningDisabled(): boolean {
        return true;
    }

    get hideTtl(): number | false {
        return this.options.hideTtl ? parseInt(this.options.hideTtl) : false;
    }

    get hidePath(): string {
        return this.options.hidePath ? this.options.hidePath : "/";
    }

    publish(): void {
        if (Object.keys(this.options).length === 0) {
            throw new Error("No options detected. Please consult documentation.");
        }

        SmartBannerAnalytics.pushImpression(this.dataLayerAppCode, this.platform);

        const event = new Event("smartbanner.view");
        document.dispatchEvent(event);

        const dataLayerAppCode = this.dataLayerAppCode;
        const platform = this.platform;
        const smartbannerButton = document.querySelector<HTMLElement>(".smartbanner__button");
        smartbannerButton?.addEventListener("click", (event) => {
            const appUrl = smartbannerButton.dataset.app;
            const fallbackUrl = smartbannerButton.dataset.link;

            if (appUrl) {
                event.preventDefault();
                window.location.assign(appUrl);
                if (fallbackUrl) {
                    setTimeout(() => {
                        window.location.assign(fallbackUrl);
                    }, 500);
                }
            }

            SmartBannerAnalytics.pushClick(dataLayerAppCode, platform);
        });

        addEventListeners(this);
    }

    exit(): void {
        document.documentElement.classList.remove("has-smartbanner", "has-smartbanner--at-top");
        const event = new Event("smartbanner.exit");
        document.dispatchEvent(event);
        Bakery.bake(this.hideTtl, this.hidePath);
    }

    clickout(): void {
        const event = new Event("smartbanner.clickout");
        document.dispatchEvent(event);
    }

    trackClose(): void {
        SmartBannerAnalytics.pushClose(this.dataLayerAppCode, this.platform);
    }
}

function handleExitClick(event: MouseEvent, smartBanner: SmartBanner): void {
    smartBanner.trackClose();
    smartBanner.exit();
    event.preventDefault();
}

function handleClickout(smartBanner: SmartBanner): void {
    smartBanner.clickout();
}

function addEventListeners(smartBanner: SmartBanner): void {
    const closeIcon = document.querySelector<HTMLElement>(".js_smartbanner__exit");
    closeIcon?.addEventListener("click", (event) => handleExitClick(event, smartBanner));

    const button = document.querySelector<HTMLElement>(".smartbanner__button");
    button?.addEventListener("click", () => handleClickout(smartBanner));
}
